import { inject } from "@angular/core";
import { CanActivateFn, Router, UrlTree } from "@angular/router";
import { AuviousRtcService, GenericErrorHandler } from "../../../core-ui";
import { ErrorPageSubCode, ErrorPageCode } from "../../app.enums";

import { isAuviousCoreSupported } from "@auvious/compatibility";

export const compatibilityGuard: CanActivateFn = (route, state): UrlTree | boolean => {
  const router = inject(Router);
  const errorHandler = inject(GenericErrorHandler);
  const rtcService = inject(AuviousRtcService);

  if (isAuviousCoreSupported()) {
    return true;
  } else {
    return router.createUrlTree(
      ["/error", ErrorPageCode.NOT_SUPPORTED],
      {
        queryParams: {
          code: ErrorPageSubCode.UNSUPPORTED_BROWSER,
          url: escape(state.url),
        },
      }
    );
  }
};
